var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuscadorActivo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12 8.76143 9.76142 11 7 11C4.23858 11 2 8.76143 2 6C2 3.23858 4.23858 1 7 1C9.76142 1 12 3.23858 12 6ZM10.2924 11.0168C9.34721 11.6384 8.21584 12 7 12C3.68629 12 1 9.31371 1 6C1 2.68629 3.68629 0 7 0C10.3137 0 13 2.68629 13 6C13 7.73753 12.2614 9.30256 11.0811 10.3983L15.0372 14.7939C15.2219 14.9991 15.2053 15.3153 15 15.5C14.7947 15.6847 14.4786 15.6681 14.2939 15.4628L10.2924 11.0168Z",
    fill: "#002EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscadorActivo);
export default __webpack_public_path__ + "static/media/buscador-activo.2adcb7ed4d5c123cf404a036c0fd5219.svg";
export { ForwardRef as ReactComponent };